import React from 'react';

import Container1 from "./components/Container1"
import Container2 from "./components/Container2"

import './App.css';

function App() {
  return (
    <div>
      
      <Container1 />

      <Container2 />
      
    </div>
  );
}

export default App;
